import{isObject as a,isNonEmptyString as r}from"@guildeducationinc/type-guards";var e=function(e){return a(e)&&(!("className"in e)||r(e.className))};export{e as isStylable};
//# sourceMappingURL=Stylable.js.map
